import request from '@/http/request'

export const configQuery = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/system/config/query`, params, {
    hiddenError: true,
    noSpin: true
  })
}
